import React from 'react'
import env from './../../../../environments/environment'
import appConstants from './../../../../constants/appConstants'

import './TrustBadges.component.scss'

const BBB_BADGE = `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Flogos%2Flogo.bbb.png?alt=media`

const TrustBadges = () => (
  <section id='TrustBadges' className='subsite-section'>
    <div className='subsite-shell trust-grid'>
      <div className='trust-item'>
        <img src={appConstants.badges.experience} alt='USA Benefits Group — 38 years serving customers since 1988' />
      </div>
      <div className='trust-item'>
        <img src={appConstants.logos.plain.md} alt='USA Benefits Group — Health, Life & Senior Insurance' />
      </div>
      <div className='trust-item'>
        <img src={BBB_BADGE} alt='BBB Accredited Business — A+ rating' />
      </div>
    </div>
  </section>
)

export default TrustBadges
